import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Spinner } from "reactstrap";
import { redirectToOrganizationDomain } from "../../hooks/saveTokenDomain";
import SubscriptionForm from "./SubscriptionForm";

const stripeKey=process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const stripePromise = loadStripe(stripeKey);

// TEMP: the payment / subscription step is disabled - members go straight to the site.
// Every entry point (login, register, general-subscription, AskPaymentModal) still
// navigates to /payment, so this single flag short-circuits all of them.
// Set to false to re-enable the form below, or delete both once it's retired for good.
const BYPASS_PAYMENT = true;

const StripeWrapper = () => {
    const [clientSecret, setClientSecret] = useState("");

    // Skip payment entirely and hand the member off to their organization domain.
    useEffect(() => {
        if (!BYPASS_PAYMENT) return;

        const stored = localStorage.getItem("responseUser");
        const user = stored ? JSON.parse(stored) : null;

        if (user?.meta?.token) {
            redirectToOrganizationDomain(user);
        } else {
            window.location.replace("/login");
        }
    }, []);

    useEffect(() => {
        if (BYPASS_PAYMENT) return;
        fetch(`${process.env.REACT_APP_TRIP_MERCHANT_API_KEY}/stripe/setup-intent`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`, // assuming sanctum/JWT
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setClientSecret(data.client_secret);
            })
            .catch((error) => {
                console.error("Error fetching setup intent:", error);
            });
    }, []);

    const options = {
        clientSecret,
        appearance: {
    // theme: "stripe", // or 'flat', 'night', 'none'
            theme: 'stripe', // ✅ removes default styling
            variables: {
                colorPrimary: '#F25926',
                colorBackground: 'transparent', // ✅ removes PaymentElement background
            },
        },
    };

    if (BYPASS_PAYMENT) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
                <Spinner style={{ color: "#F25926" }} />
            </div>
        );
    }

    return (
        clientSecret && (
            <Elements stripe={stripePromise} options={options}>
                <SubscriptionForm/>
            </Elements>
        )
    );
};

export default StripeWrapper;
